import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";

export const filtersDefs: Array<Filter> = [
  {
    name: 'name',
    label: 'Report Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'created',
    label: 'Created',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'updated',
    label: 'Last Updated',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
];
